import { Theme } from '@mui/material';

export const cardSx = {
  '&.MuiPaper-elevation0': {
    '&.MuiCard-root': {
      boxShadow: (theme: Theme) => theme.boxShadow[3],
      borderRadius: (theme: Theme) => theme.shape.borderRadius * 2,
      width: '100%',
      padding: '16px',
    },
    '& .MuiCardContent-root': {
      width: '100%',
    },
  },
} as const;
